/**
*	@author Camilo
*	@since  02/11/2017
**/
export class FacturaModel{

	constructor(public enviar:boolean, 
		public cnumcont:string,
		public vnombrenegocio:string,
		public ciddoc:string,
		public cnumdoc:string,
		public ctipid:string,
		public cnumid:string,
		public vnumliq:string,
		public dfecmov:Date,
		public valor:number, 
		public cidregter:string,
		public nombreCliente:string){}

}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/EnviarFacturas/Factura.model.ts